var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrap"},[_c('ChartHeader',{attrs:{"y-name":"占比(%)","legend":_vm.legend}}),_c('div',{staticClass:"scroll-warp",style:({width: '100%', overflow: 'auto'})},[_c('div',{staticClass:"scroll-inner",style:({
        width:
          _vm.scrollNumber && _vm.valLength > _vm.scrollNumber
            ? _vm.valLength * _vm.scrollItemWidth + 'px'
            : 'auto'
      })},[_c('Chart',{ref:"chart",attrs:{"id":("chart_" + _vm.chartId),"height":"300px","width":"100%","options":_vm.option}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }